import { apiClient } from '@/utils/api-client'

/**
 * Target value service for updating target values.
 */
class TargetValueService {
    /**
     * Update the value assigned to a target.
     *
     * @param {string} projectKey - Project key
     * @param {string} environmentKey - Environment key
     * @param {string} targetUlid - Target ULID
     * @param {string} valueUlid - Value ULID
     * @returns {Promise<Object>} Update response
     */
    async update(projectKey, environmentKey, targetUlid, valueUlid) {
        return await apiClient
            .put(
                '/projects/' +
                    projectKey +
                    '/environments/' +
                    environmentKey +
                    '/targets/' +
                    targetUlid +
                    '/values/' +
                    valueUlid,
                []
            )
            .then((response) => {
                return response.data
            })
    }
}

export default new TargetValueService()
